<template>
  <div class="threepage">
    <!-- 新闻1文本图片 -->
    <div v-if="currentPage == 1" class="text-container">
      <img v-if="isPortrait" src="/assets/~/media/images/activity/aowang2025/thirdpage-text-withhead-mob2.png" alt="">
      <img  v-else src="/assets/~/media/images/activity/aowang2025/thirdpage-text-withhead-pc2.png" alt="">
    </div>
    <!-- 新闻2文本图片 -->
    <div v-if="currentPage == 2" class="text-container">
      <img v-if="isPortrait" src="/assets/~/media/images/activity/aowang2025/thirdpage-text-withhead-mob3.png" alt="">
      <img  v-else src="/assets/~/media/images/activity/aowang2025/thirdpage-text-withhead-pc3.png" alt="">
    </div>
    <!-- 新闻3文本图片 -->
    <div v-if="currentPage == 3" class="text-container">
      <img v-if="isPortrait" src="/assets/~/media/images/activity/aowang2025/thirdpage-text-withhead-mob.png" alt="">
      <img  v-else src="/assets/~/media/images/activity/aowang2025/thirdpage-text-withhead-pc.png" alt="">
    </div>

    <div ref="slideCarousel" class="carousel-container" style="overflow: hidden;">
            <!-- 新闻1轮播 -->
            <div v-if="currentPage == 1" class="swiper-wrapper">
                <div class="swiper-slide" style="height: 100%;" v-for="item in imgUrls2" :key="item.index">
                    <img v-if="isPortrait" style="opacity:1;width: 100%;height: 100%;" :src="preText + item.urlmb">
                    <img v-else style="opacity:1;width: 100%;" :src="preText + item.url">
                 </div>
            </div>
            <!-- 新闻2轮播 -->
            <div v-if="currentPage == 2" class="swiper-wrapper">
                <div class="swiper-slide" style="height: 100%;" v-for="item in imgUrls3" :key="item.index">
                    <img v-if="isPortrait" style="opacity:1;width: 100%;height: 100%;" :src="preText + item.urlmb">
                    <img v-else style="opacity:1;width: 100%;"   :src="preText + item.url">
                 </div>
            </div>
            <!-- 新闻3轮播 -->
            <div v-if="currentPage == 3" class="swiper-wrapper">
                <div class="swiper-slide" style="height: 100%;" v-for="item in imgUrls" :key="item.index">
                    <img v-if="isPortrait" style="opacity:1;width: 100%;height: 100%;" :src="preText + item.urlmb">
                    <img v-else style="opacity:1;width: 100%;"   :src="preText + item.url">
                 </div>
            </div>
            <div class="swiper-pagination-kv2">
        </div>
    </div>

    <div class="btn-box" @click="learnMore" code-stm="event, PAGEURL, 了解详情">了解详情</div>

    <div class="news-pagination">
      <div class="btn-last" v-if="currentPage !== 1" @click="pageChange('last')" code-stm="event, PAGEURL, 新闻切换0">
        上篇
      </div>
      <div class="btn-none" v-else ></div>
      <div class="btn-next" v-if="currentPage !== 3" @click="pageChange('next')" code-stm="event, PAGEURL, 新闻切换0">
        下篇
      </div>
      <div class="btn-none" v-else ></div>
      <!-- <div :class="currentPage == 1 ? 'news-pagination-active' : ''" @click="pageChange(1)" code-stm="event, PAGEURL, 新闻切换1">1</div>
      <div :class="currentPage == 2 ? 'news-pagination-active' : ''" @click="pageChange(2)" code-stm="event, PAGEURL, 新闻切换2">2</div>
      <div :class="currentPage == 3 ? 'news-pagination-active' : ''" @click="pageChange(3)" code-stm="event, PAGEURL, 新闻切换3">3</div> -->
    </div>
  </div>
</template>
<script>
import { isPortraitFun, isPc, isWeiXin, isAndroid } from "@/utils/utils.js";
import Swiper from "swiper";

export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      preText:'https://www.kia.cn',
      imgUrls: [
        {
          index: 0,
          url: '/assets/~/media/images/activity/aowang2025/carousel-pc-01.png',
          urlmb: '/assets/~/media/images/activity/aowang2025/carousel-mob-1.png',
        },
        {
          index: 1,
          url: '/assets/~/media/images/activity/aowang2025/carousel-pc-02.png',
          urlmb: '/assets/~/media/images/activity/aowang2025/carousel-mob-2.png',
        },
        {
          index: 2,
          url: '/assets/~/media/images/activity/aowang2025/carousel-pc-03.png',
          urlmb: '/assets/~/media/images/activity/aowang2025/carousel-mob-3.png',
        },
        {
          index: 3,
          url: '/assets/~/media/images/activity/aowang2025/carousel-pc-04.png',
          urlmb: '/assets/~/media/images/activity/aowang2025/carousel-mob-4.png',
        },
        {
          index: 4,
          url: '/assets/~/media/images/activity/aowang2025/carousel-pc-05.png',
          urlmb: '/assets/~/media/images/activity/aowang2025/carousel-mob-5.png',
        },
        {
          index: 5,
          url: '/assets/~/media/images/activity/aowang2025/carousel-pc-06.png',
          urlmb: '/assets/~/media/images/activity/aowang2025/carousel-mob-6.png',
        },
        {
          index: 6,
          url: '/assets/~/media/images/activity/aowang2025/carousel-pc-07.png',
          urlmb: '/assets/~/media/images/activity/aowang2025/carousel-mob-7.png',
        },
        {
          index: 7,
          url: '/assets/~/media/images/activity/aowang2025/carousel-pc-08.png',
          urlmb: '/assets/~/media/images/activity/aowang2025/carousel-mob-8.png',
        },
        {
          index: 8,
          url: '/assets/~/media/images/activity/aowang2025/carousel-pc-09.png',
          urlmb: '/assets/~/media/images/activity/aowang2025/carousel-mob-9.png',
        }
        // {
        //   index: 9,
        //   url: '/assets/~/media/images/activity/aowang2025/carousel-pc-10.png',
        //   urlmb: '/assets/~/media/images/activity/aowang2025/carousel-mob-10.png',
        // },
      ],
      imgUrls2: [
        {
          index: 0,
          url: '/assets/~/media/images/activity/aowang2025/carousel2-pc-011.png',
          urlmb: '/assets/~/media/images/activity/aowang2025/carousel2-mob-11.png',
        },
        {
          index: 1,
          url: '/assets/~/media/images/activity/aowang2025/carousel2-pc-021.png',
          urlmb: '/assets/~/media/images/activity/aowang2025/carousel2-mob-21.png',
        },
        {
          index: 2,
          url: '/assets/~/media/images/activity/aowang2025/carousel2-pc-01.png',
          urlmb: '/assets/~/media/images/activity/aowang2025/carousel2-mob-1.png',
        },
        {
          index: 3,
          url: '/assets/~/media/images/activity/aowang2025/carousel2-pc-02.png',
          urlmb: '/assets/~/media/images/activity/aowang2025/carousel2-mob-2.png',
        }
        // ,
        // {
        //   index: 4,
        //   url: '/assets/~/media/images/activity/aowang2025/carousel2-pc-03.png',
        //   urlmb: '/assets/~/media/images/activity/aowang2025/carousel2-mob-3.png',
        // },
        // {
        //   index: 5,
        //   url: '/assets/~/media/images/activity/aowang2025/carousel2-pc-04.png',
        //   urlmb: '/assets/~/media/images/activity/aowang2025/carousel2-mob-4.png',
        // }
      ],
      imgUrls3: [
      {
          index: 0,
          url: '/assets/~/media/images/activity/aowang2025/carousel3-pc-01.png',
          urlmb: '/assets/~/media/images/activity/aowang2025/carousel3-mob-1.png',
        },
        {
          index: 1,
          url: '/assets/~/media/images/activity/aowang2025/carousel3-pc-02.png',
          urlmb: '/assets/~/media/images/activity/aowang2025/carousel3-mob-2.png',
        },
        {
          index: 2,
          url: '/assets/~/media/images/activity/aowang2025/carousel3-pc-03.png',
          urlmb: '/assets/~/media/images/activity/aowang2025/carousel3-mob-3.png',
        },
        {
          index: 3,
          url: '/assets/~/media/images/activity/aowang2025/carousel3-pc-04.png',
          urlmb: '/assets/~/media/images/activity/aowang2025/carousel3-mob-4.png',
        }
      ],
      currentPage: 1,
    }
  },
  computed: {
    isSafari() {
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("Safari") > -1) {
        return true
      } else {
        return false
      } //判断是否Safari浏览器
    }
  },
  watch: {

  },
  mounted() {
    if (!window.location.href.includes("https://www.kia.cn")) {
      this.preText = 'https://uat.kia.cn'
    }else{
      this.preText = 'https://www.kia.cn'
    }
    // this.slideBanner()
    window.addEventListener("resize", this.setResize);

    this.$nextTick(()=>{
        this.swiper = new Swiper(".carousel-container", {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            // sliderPerview: 'auto',
            // loopAdditionalSlides: 5,
            loopFillGroupWithBlank: false,
            autoplayDisableOnInteraction : false,
            autoplay: {
                delay: 5000,
                 disableOnInteraction: false,
            },
            pagination: {
            el: ".swiper-pagination-kv2",
            },
            navigation: {
            nextEl: "#swiper-button-next",
            prevEl: "#swiper-button-prev",
            },
            on: {
            slideChangeTransitionEnd: this.slideChangeTransitionEnd,
            },
        });
    })

  },
  destroyed() {
    window.removeEventListener("resize", this.setResize);
  },
  methods: {
    // 新闻切换
    pageChange(type){
      // if(this.currentPage !== index){
      if(type == 'last'){
        this.currentPage = this.currentPage - 1
      }else{
        this.currentPage = this.currentPage + 1
      }
        // this.currentPage = index
        this.swiper.destroy();
        this.$nextTick(()=>{
          this.swiper = new Swiper(".carousel-container", {
              slidesPerView: 1,
              spaceBetween: 0,
              loop: true,
              // sliderPerview: 'auto',
              // loopAdditionalSlides: 5,
              loopFillGroupWithBlank: false,
              autoplayDisableOnInteraction : false,
              autoplay: {
                  delay: 5000,
                  disableOnInteraction: false,
              },
              pagination: {
              el: ".swiper-pagination-kv2",
              },
              navigation: {
              nextEl: "#swiper-button-next",
              prevEl: "#swiper-button-prev",
              },
              on: {
              slideChangeTransitionEnd: this.slideChangeTransitionEnd,
              },
          });
        })
      // }
    },
    //了解更多
    learnMore(){
      if(this.currentPage == 1){
        window.open('https://www.kia.cn/brand/news/official-news/2023122901/2024112601/')
      }else if(this.currentPage == 2){
        window.open('https://www.kia.cn/activity/2024/11/GZautoShow/index.html#/')
      }else if(this.currentPage == 3){
        window.open('https://www.kia.cn/brand/news/official-news/2023122901/2024102201/')
      }
    },
    // 滑动切换
    slideBanner() {
      console.log("滑动切换");
      //选中的轮播图
      var box = document.querySelector('.el-carousel__container');
      box.onClick = (()=>{console.log("点击el-carousel");})
      var startPointX = 0
      var stopPointX = 0
      //重置坐标
      var resetPoint = function () {
        startPointX = 0
        stopPointX = 0
      }
      //手指按下
      box.addEventListener("touchstart", function (e) {
        //手指点击位置的X坐标
        startPointX = e.changedTouches[0].pageX
      });
      //手指滑动
      box.addEventListener("touchmove", function (e) {
        //手指滑动后终点位置X的坐标
        stopPointX = e.changedTouches[0].pageX
      });
      //当手指抬起的时候，判断图片滚动离左右的距离
      let that = this
      box.addEventListener("touchend", function (e) {
        if (stopPointX == 0 || startPointX - stopPointX == 0) {
          console.log("a");
          resetPoint()
          return
        }
        if (startPointX - stopPointX > 0) {
          resetPoint()
          that.$refs.slideCarousel.next()
          console.log("b");
          return
        }
        if (startPointX - stopPointX < 0) {
          resetPoint()
          that.$refs.slideCarousel.prev()
          console.log("c");
          return
        }
      });
    },
    toev5() {
      window.open('https://www.kia.cn/vehicles/ev6/')
    },

    slideChangeTransitionEnd() {
    //   this.playVideo(this.swiper?.activeIndex);
    //   this.pauseVideo(this.swiper?.previousIndex);
    },
    setResize() {
      this.isPortrait = isPortraitFun();
    },
  },
}
</script>
<style  lang="scss" scoped>
//pc start
@media (min-width: 767px) {
  .swiper-pagination-kv2{
    bottom: 20px!important;
  }
.threepage {
  position: relative;
  height: 100vh;
  width: 100%;
  user-select: none;
  background-image: url('https://www.kia.cn/assets/~/media/images/activity/aowang2025/third-page-background-pc.png');
  background-repeat: no-repeat; /* 防止重复 */
  // background-position: center; /* 图片居中 */
  // background-size:100% 100%
  background-size: cover;
}
.carousel-hover-stripe{
  position: absolute;
  left: calc(110 / 1920 * 100vw);
  top: calc(50% - 339 / 1920 * 100vw );
  width: calc(1206 / 1920 * 100vw);
  height: calc(105 / 1920 * 100vw);
  // font-size: calc(34 / 1920 * 100vw);
    font-family: 'zhonghei';
  background-image: url('https://www.kia.cn/assets/~/media/images/activity/aowang2025/purple-stripe-pc.png');
  background-repeat: no-repeat; /* 防止重复 */
  // background-position: center; /* 图片居中 */
  background-size:100% 100%;
  z-index: 99;
}
.carousel-container {
  width: calc(1206 / 1920 * 100vw);
  height: calc(678 / 1920 * 100vw);
  position: absolute;
  left: 0;
  top: calc(50% - 339 / 1920 * 100vw );
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 calc(30 / 1920 * 100vw) 0 calc(110 / 1920 * 100vw) ;
}
.text-container {
  width: calc(484 / 1920 * 100vw);
  height: calc(674 / 1920 * 100vw);
  position: absolute;
  right: calc(70 / 1920 * 100vw);
  top: calc(50% - 339 / 1920 * 100vw );
  display: flex;
  flex-direction: column;
  justify-content: space-between;
    font-family: 'zhonghei';
  letter-spacing: calc(2 / 1920 * 100vw);
  color: white;
 img {
  // margin-top: calc(60 / 1920 * 100vw);
  width: calc(470 / 1920 * 100vw);
  height: calc(485 / 1920 * 100vw);
 }
  .first-title-box {
    padding:calc(4 / 1920 * 100vw) 0 calc(4 / 1920 * 100vw) calc(4 / 1920 * 100vw);
    border: solid 2px white;
    width: 90%;
    font-size: calc(40 / 1920 * 100vw);
    font-family: 'zhonghei';
    margin-bottom: calc(34 / 1920 * 100vw)
  }
  .first-title-en {
    font-size: calc(34 / 1920 * 100vw);
  }
  .divise-fat {
    border: solid 1px white;
    width: 90%;
  }
  .second-title-box {
    padding: calc(34 / 1920 * 100vw) 0;
    font-size: calc(24 / 1920 * 100vw);
  }

  .divise-thin {
    border-top: dashed 1px white;
    width: 95%;
  }
  .third-text {
    width: 95%;
    height: calc(250 / 1920 * 100vw);
    font-size: calc(14 / 1920 * 100vw);
    line-height: calc(36 / 1920 * 100vw);
  }

}
.btn-box {
  position: absolute;
  border: solid 1px white;
  border-radius: 4px;
  color: white;
  padding: calc(5 / 1920 * 100vw)  calc(8 / 1920 * 100vw) calc(2 / 1920 * 100vw) calc(8 / 1920 * 100vw);
  font-size: calc(18 / 1920 * 100vw);
  left:calc(1345 / 1920 * 100vw);
  top: calc(50% + 339 / 1920 * 100vw - 40 / 1920 * 100vw - 80 / 1920 * 100vw);
  cursor: pointer;
  font-family: 'heijian';
}
.news-pagination {
  position: absolute;
  width: calc(470 / 1920 * 100vw);
  left:calc(1345 / 1920 * 100vw);
  top: calc(50% + 339 / 1920 * 100vw - 35 / 1920 * 100vw );
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
    font-size: calc(20 / 1920 * 100vw);
    color: #fff;
    margin-right: calc(14 / 1920 * 100vw);
    padding: 0 calc(4 / 1920 * 100vw);
    cursor: pointer;
  }
  .news-pagination-active{
    
  }
  .btn-last {
    font-size: calc(20 / 1920 * 100vw);
    &:before {
      content: "\e66d";
      font-family: icon;
      font-size: calc(20 / 1920 * 100vw);
      width: calc(16 / 1920 * 100vw);
      display: inline-block;
      text-align: center;
      transition: 0.3s;
      vertical-align: 0px;
    }
  }
  .btn-next {
    font-size: calc(20 / 1920 * 100vw);
    &:after {
      content: "\e628";
      font-family: icon;
      font-size: calc(20 / 1920 * 100vw);
      width: calc(16 / 1920 * 100vw);
      display: inline-block;
      text-align: center;
      transition: 0.3s;
      vertical-align: -1px;
    }
  }
}
}
//pc end
//mob strat
@media (max-width: 767px) {
  .threepage {
  position: relative;
  height: calc(600 / 375 * 100vw );
  width: 100%;
  user-select: none;
  background-image: url('https://www.kia.cn/assets/~/media/images/activity/aowang2025/third-page-background-mob.png');
  background-repeat: no-repeat; /* 防止重复 */
  // background-position: center; /* 图片居中 */
  // background-size:100% 100%;
  background-size: cover;
  padding-top: calc(50 / 375 * 100vw );
  padding-bottom: calc(80 / 375 * 100vw );
}
.carousel-hover-stripe{
  position: absolute;
  left: calc(26.5 / 375 * 100vw);
  bottom: calc((50 - 40 + 357) / 375 * 100vw );
  width: calc(322.1 / 375 * 100vw);
  height: calc(40 / 375 * 100vw);
  border-radius: 15px 15px 0 0;
  // font-size: calc(34 / 1920 * 100vw);
    font-family: 'zhonghei';
  background-image: url('https://www.kia.cn/assets/~/media/images/activity/aowang2025/purple-stripe-mob.png');
  background-repeat: no-repeat; /* 防止重复 */
  // background-position: center; /* 图片居中 */
  background-size:100% 100%;
  z-index: 99;
}
.carousel-container {
  width: calc(322 / 375 * 100vw);
  height: calc(216.67 / 375 * 100vw);
  // position: absolute;
  margin-left: calc(26.5 / 375 * 100vw);
  // padding-bottom: calc(50 / 375 * 100vw );
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // border-radius: calc(15 / 375 * 100vw);
}
.text-container {
  width: calc(322 / 375 * 100vw);
  // position: absolute;
  margin-left: calc(26.5 / 375 * 100vw);
  padding-bottom: calc(75 / 375 * 100vw);
  // padding-top: calc(50 / 375 * 100vw );
  display: flex;
  flex-direction: column;
  justify-content: space-between;
    font-family: 'zhonghei';
  letter-spacing: calc(2 / 375 * 100vw);
  color: white;
  
  img {
    width: calc(322 / 375 * 100vw);
    height: calc(158.67 / 375 * 100vw);
 }
  .first-title-box {
    padding:calc(1 / 375 * 100vw) calc(6 / 375 * 100vw);
    border: solid 2px white;
    width: 75%;
    font-size: calc(20 / 375 * 100vw);
    font-family: 'Kia Signature';
    margin-bottom: calc(20 / 375 * 100vw);
    font-family: 'zhonghei';

  }
  .first-title-en {
    font-size: calc(16 / 375 * 100vw);
  }
  .divise-fat {
    display: none;
  }
  .second-title-box {
    padding: calc(20 / 375 * 100vw) 0;
    font-size: calc(14 / 375 * 100vw);
    font-family: 'zhonghei';

  }

  .divise-thin {
    border-top: dashed 1px white;
    width: 100%;
  }
  .third-text {
    // height: calc(80 / 375 * 100vw);
    font-size: calc(10 / 375 * 100vw);
    line-height: calc(35 / 375 * 100vw);
    font-family: 'zhonghei';
    padding-bottom: calc(10 / 375 * 100vw);

  }

}
.btn-box {
  position: absolute;
  border: solid 1px white;
  border-radius: 2px;
  color: white;
  padding: calc(5 / 375 * 100vw) calc(8 / 375 * 100vw);
  font-size: calc(11 / 375 * 100vw);
  right:calc(27 / 375 * 100vw);
  top: calc(225 / 375 * 100vw);
}
.news-pagination {
  position: absolute;
  width: calc(285 / 375 * 100vw);
  top: calc(530 / 375 * 100vw);
  margin-left: calc(45 / 375 * 100vw);
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
    color: #fff;
    // padding: 0 calc(8 / 375 * 100vw);
  }
  .news-pagination-active{
    
  }
  .btn-last {
    font-size: calc(12 / 375 * 100vw);
    &:before {
      content: "\e66d";
      font-family: icon;
      font-size: calc(12 / 375 * 100vw);
      width: calc(16 / 375 * 100vw);
      display: inline-block;
      text-align: center;
      transition: 0.3s;
      vertical-align: -1px;
    }
  }
  .btn-next {
    font-size: calc(12 / 375 * 100vw);
    &:after {
      content: "\e628";
      font-family: icon;
      font-size: calc(12 / 375 * 100vw);
      width: calc(16 / 375 * 100vw);
      display: inline-block;
      text-align: center;
      transition: 0.3s;
      vertical-align: -1px;
    }
  }
}
}

@media screen and (orientation: portrait) {

  //隐藏掉鼠标悬浮出现的左右切换按钮
  ::v-deep .el-carousel__arrow {
    display: none;
  }
  .swiper-pagination-kv2{
    top: calc(475 / 375 * 100vw) !important;
    bottom: calc(485 / 375 * 100vw) !important;
  }

}

::v-deep .el-carousel__indicators {
  // display: none;
  bottom: 0;
}
::v-deep  .el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 10px;
}
::v-deep .is-active .el-carousel__button {
  // background-color: #ffffff;
  background: rgba(0, 80, 255, 1);
  width: 10px;
  height: 10px;
  border-radius: 10px;
}

//隐藏掉鼠标悬浮出现的左右切换按钮
// ::v-deep .el-carousel__arrow{
//   display: none;
// }
::v-deep .el-carousel__arrow {
  background-color: #ffffff;

  i {
    font-size: 30px;
  }
}

.el-carousel__arrow:hover {
  background-color: #475669;
}

::v-deep .el-carousel__container {
  position: relative;
  height: 100%;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #ffffff;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #ffffff;
}

 .swiper {
      width: 100%;
      height: 400px;
    }

    .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    // .swiper-slide img {
    //   display: block;
    //   width: 100%;
    //   height: 100%;
    //   object-fit: cover;
    // }
    .swiper-pagination-kv2 {
      position: absolute;
      bottom: 70px;
      left: 0;
      width: 100%;
      text-align: center;
      z-index: 10;
    }
</style>
